import moment from 'moment';

import template from './template.html';

function Directive($timeout, $interval) {
  return {
    restrict: 'E',
    replace: true,
    template,
    scope: {
      date: '='
    },
    link($scope) {
      countdown();

      $interval(countdown, 1000);

      function countdown() {
        const now = moment();
        let then = moment($scope.date || new Date());

        let ms = then.diff(now, 'milliseconds', true);
        // If you need years, uncomment this line and make sure you add it to the concatonated phrase
        /*
        years = Math.floor(moment.duration(ms).asYears());
        then = then.subtract('years', years);
        */
        // update the duration in ms
        ms = then.diff(now, 'milliseconds', true);

        // subtract months from the original moment (not sure why I had to offset by 1 day)
        //then = then.subtract('months', months).subtract('days', 1);
        // update the duration in ms
        ms = then.diff(now, 'milliseconds', true);
        const days = Math.floor(moment.duration(ms).asDays());

        then = then.subtract(days, 'days');
        // update the duration in ms
        ms = then.diff(now, 'milliseconds', true);
        const hours = Math.floor(moment.duration(ms).asHours());

        then = then.subtract(hours, 'hours');
        // update the duration in ms
        ms = then.diff(now, 'milliseconds', true);
        const minutes = Math.floor(moment.duration(ms).asMinutes());

        then = then.subtract(minutes, 'minutes');
        // update the duration in ms
        ms = then.diff(now, 'milliseconds', true);
        const seconds = Math.floor(moment.duration(ms).asSeconds());

        $scope.countdownDays = days;
        $scope.countdownHours = hours;
        $scope.countdownMinutes = minutes;
        $scope.countdownSeconds = seconds;
      }
    }
  };
}

Directive.$inject = [
  '$timeout',
  '$interval'
];

export default Directive;



// WEBPACK FOOTER //
// ./src/directives/countdown/index.js